import React, { useEffect, useState } from 'react';
import './MosollaLanding.css'
import logo from '../../../Images/dlogo/deshilogo.png'
import poster from '../../../Images/Posters/ps1.jpg'
import { PiShoppingCartFill } from "react-icons/pi";
import poster2 from '../../../Images/Posters/ps2.png'
import { BsCart4 } from "react-icons/bs";
import ProductCarousel from '../../Components/ProductCarousel/ProductCarousel';
import WhyChoose from './WhyChoose/WhyChoose';
import ItemCatg from './ItemCatg/ItemCatg';
import MosollaSpeciality from './MosollaSpeciality/MosollaSpeciality';
import QualityCheck from './QualityCheck/QualityCheck';
import { IoCall } from "react-icons/io5";
import { IoLogoWhatsapp } from "react-icons/io";
import OrderProcess from './OrderProcess/OrderProcess';
import Accordion from 'react-bootstrap/Accordion';
import { toast, ToastContainer } from 'react-toastify';
import { liveServerUrl, serverUrl } from '../../../Shared/constant';
import { Navigate, useNavigate } from 'react-router-dom';


const MosollaLanding = () => {




    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [address, setAddress] = useState('')
    const [productCatg, setProductCatg] = useState('700')
    const [prodTitle, setProdTitle] = useState('')
    const [productPrice, setProductPrice] = useState(700)
    const [deliveryMethod, setDeliveryMethod] = useState('60')
    const [deliveryFee, setDeliveryFee] = useState(60)

    const handleOnchaneName = (e) => {
        setName(e.target.value)
    }
    const handleOnchaneNumber = (e) => {
        setPhone(e.target.value)
    }
    const handleOnchaneAddress = (e) => {
        setAddress(e.target.value)
    }
    // product category with price here 


    const handleProdCatg = (e) => {
        setProductCatg(e.target.value)
    }

    useEffect(() => {
        if (productCatg == '700') {
            setProdTitle('গুঁড়া মসলা ছোট প্যাক ৮০০ গ্রাম')
            setProductPrice(700)
        }
        else {
            setProdTitle('গুঁড়া মসলা ফ্যামিলি প্যাক ২০০০ গ্রাম')
            setProductPrice(1300)
        }

    }, [productCatg])


    const handledeliveryMe = (e) => {
        setDeliveryMethod(e.target.value)
    }


    useEffect(() => {

        if (deliveryMethod === '60') {
            setDeliveryFee(60)
        }
        else {
            setDeliveryFee(120)
        }



    }, [deliveryMethod])
    console.log(deliveryMethod)



    // total price here 
    const totalPrice = deliveryFee + productPrice

    const orderInfo =
    {
        name: name,
        phone: phone,
        address: address,
        total: totalPrice,
        deliveryFee: deliveryFee,
        productPrice: productPrice,
        productTitle: prodTitle,
        tags: 'mosolla small pack',
        category: 'mosolla combo'
    }


    const [value, setValue] = useState()
    const navigate = useNavigate();


    const getOrder = async () => {

        const res = await fetch(`${liveServerUrl}/api/mosollaLanding`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(orderInfo)
        }
        );
        const data = await res.json();
        console.log(data.success)
        if (data.success) {
            if (data.success) {
                toast('Woow,your order done')
                navigate("/orderSuccess");
            }
            else {
                toast('oopps, sorry order not ok')
            }
        }
        else {
            toast('wait for confirm')
        }


    }

    const inform = () => {

    }



    return (
        <>
            {/* parent part */}

            <section className='bodyContainer'>
                <section style={{ width: '100%' }} className='heroSection'>

                    <div className='logoContainer'>
                        <img src={logo} alt="" />
                    </div>
                    <h1>দেশি এগ্রো ফুডস </h1>
                    <p>কৃষকের হাতের বিশুদ্ধ ছোঁয়া !!</p>
                </section>
                <section className='herotop'>
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', height: '90%', justifyContent: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: ' 0 10px' }}>
                            <p className='text2'>
                                "খাঁটি স্বাদের নিশ্চয়তা—প্রতিটি দানায় প্রাকৃতিক মসলার সুবাসে তৈরি আমাদের গুঁড়া মসলা।
                                রান্নায় আনুন আসল দেশি স্বাদ।
                                বিশুদ্ধতা, ঘ্রাণ আর স্বাদের অনন্য সমন্বয়—আপনার প্রতিদিনের রান্নার জন্য সেরা গুঁড়া মসলা।"</p>


                        </div>
                        <button className='orderBtn'> <a href="#jumptoOrder">অর্ডার করুন</a></button>
                    </div>

                    <div>
                        <div className='Innerbanner'>
                            <img src={poster2} alt="" />
                        </div>
                    </div>
                </section>



                <section>
                    <p className='slogan'>শতভাগ বিশুদ্ধ || নিরাপদ প্রক্রিয়াজাত || বিশ্বস্ত মান </p>
                    <div className='bannerContainer'>
                        <img src={poster} alt="" />
                    </div>
                    <p className='Text1'>
                        আজই অর্ডার করুন এবং রান্নায় আনুন আসল দেশি স্বাদ!

                    </p>

                </section>
                <button className='orderButton'><PiShoppingCartFill className='shoppingCart' /> <a href="#jumptoOrder">এখনই অর্ডার করুন</a></button>

                {/* item category */}
                <section className='itemCategory'>
                    <hr /><hr />

                    <ItemCatg></ItemCatg>
                </section>


                <section>
                    <MosollaSpeciality></MosollaSpeciality>
                    <button className='orderButton'><PiShoppingCartFill className='shoppingCart' /> <a href="#jumptoOrder">এখনই অর্ডার করুন</a></button>
                </section>


                <section className='whychoose'>
                    <h1 className='customerRHead'>কেন দেশি এগ্রো ফুডস বেছে নেবেন? </h1>
                    <WhyChoose></WhyChoose>
                    <button className='orderButton'><PiShoppingCartFill className='shoppingCart' /> <a href="#jumptoOrder">এখনই অর্ডার করুন</a></button>
                </section>

                <section>
                    <h1 className='customerRHead' style={{ marginTop: '3%' }}>🏭 আমাদের মান নিয়ন্ত্রণ প্রক্রিয়া </h1>
                    <QualityCheck></QualityCheck>
                    <p className='mosollaQualityHead'>আমাদের লক্ষ্য — আপনার পরিবারের জন্য নিরাপদ ও খাঁটি মসলা পৌঁছে দেওয়া।</p>

                    <button className='orderButton'><PiShoppingCartFill className='shoppingCart' /> <a href="#jumptoOrder">এখনই অর্ডার করুন</a></button>
                </section>

                <p className='MosollaPrice'>আমাদের মসলার মূল্য</p>
                <section className='priceSection'>

                    <div>
                        <p>মসলা কম্বো ৮০০ গ্রাম মিনি প্যাকেজ </p>
                        <p> শুধুমাত্র ৭০০ টাকা</p>
                    </div>
                    <div>
                        <p>মসলা কম্বো ২০০০ গ্রাম মিনি প্যাকেজ </p>
                        <p> শুধুমাত্র ১৩০০ টাকা</p>
                    </div>
                </section>


                {/* customer review section here  */}
                <section style={{ marginTop: '2%', padding: '2%' }}>
                    <h1 className='customerRHead'>আমাদের কাস্টমারদের রিভিউ </h1>
                    <ProductCarousel></ProductCarousel>
                    <button className='orderButton'><PiShoppingCartFill className='shoppingCart' /> <a href="#jumptoOrder">এখনই অর্ডার করুন</a></button>

                </section>




                <h1 className='hotline'>Hot Line: +8801540-724544</h1>


                <section>
                    <OrderProcess></OrderProcess>
                </section>


                <p className='orderHeading'>অর্ডার করতে নিচের তথ্য পূরণ  করুন </p><hr />



                <section className='childLast' id='jumptoOrder'>

                    <div style={{ padding: '10px' }}>
                        <h3 className='orderformText'>
                            📝 অর্ডার ফর্ম
                        </h3>
                        <div className='formInput'>
                            <div>
                                <label htmlFor="">আপনার নাম:</label>
                                <input type="text" onChange={handleOnchaneName} placeholder='আপনার সম্পূর্ণ নাম লিখুন' />
                            </div>
                            <div>
                                <label htmlFor="" >আপনার মোবাইল নাম্বার:</label>
                                <input type="text" onChange={handleOnchaneNumber} placeholder='আপনার ১১ ডিজিটের নাম্বার লিখুন' />
                            </div>
                            <div>
                                <label htmlFor="" >আপনার  সম্পূর্ণ ঠিকানা:</label>
                                <input type="text" style={{ height: '100px' }} onChange={handleOnchaneAddress} placeholder='আপনার বাসা/বাড়ির সম্পূর্ণ ঠিকানা লিখুন ' />
                            </div>

                        </div>
                        <p className='formNote'>Note: আপনার  অর্ডার নিশ্চিত করার পর আমাদের কাস্টমার প্রতিনিধি আপনার সাথে সরাসরি ফোনে নিশ্চিত করবেন। </p>



                    </div>





                    <div style={{ padding: '5%', borderLeft: '2px solid' }}>
                        <p className='apnarponno'>আপনার পণ্য নির্ধারণ করুন </p>
                        <div className='cartMenu'>
                            <input
                                type="radio"
                                value='700'

                                checked={productCatg === '700'}
                                onChange={handleProdCatg} />
                            <div className='itemCart'>
                                <div style={{ height: '90%', width: '25%', border: '1px solid' }}>
                                    <img src={poster} alt="" style={{ height: '100%', width: '100%' }} />
                                </div>
                                <p className='cartDes' >গুঁড়া মসলা মিনি কম্বো প্যাক ৮০০ গ্রাম </p>
                                <p className='cartPrice'>Price: 700</p>
                            </div>
                        </div>
                        <div >
                            <div className='cartMenu'>
                                <input type="radio"
                                    value='1300'

                                    checked={productCatg === '1300'}
                                    onChange={handleProdCatg} />
                                <div className='itemCart'>
                                    <div style={{ height: '90%', width: '25%', border: '1px solid' }}>
                                        <img src={poster} alt="" style={{ height: '100%', width: '100%' }} />
                                    </div>
                                    <p className='cartDes'>গুঁড়া মসলা ফ্যামিলি কম্বো প্যাক ২০০০ গ্রাম </p>
                                    <p className='cartPrice'>Price: 1300</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '80%', margin: '2px auto' }}>
                                <p className='cartTotal'>পণ্যের মূল্য</p>
                                <p className='cartTotal'>{productPrice}.0</p>
                            </div><hr />
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '80%', margin: '2px auto' }}>
                                <p className='deliverCharge'>ডেলিভারি ফি</p>


                                <p className='deliverCharge'>{deliveryFee}.0</p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ border: '2px solid', padding: '2px', margin: '1px', borderRadius: '5px', backgroundColor: 'white' }}>
                                    <input
                                        type="radio"
                                        value='60'
                                        onChange={handledeliveryMe}
                                        checked={deliveryMethod === '60'}
                                    />
                                    <button style={{ border: 'none', backgroundColor: 'white', fontWeight: '600', fontFamily: 'tiro bangla' }}> ঢাকার ভিতরে ৬০ টাকা </button>
                                </div>

                                <div style={{ border: '2px solid', padding: '2px', margin: '1px', borderRadius: '5px', backgroundColor: 'white' }}>
                                    <input
                                        type="radio"
                                        value='120'
                                        onChange={handledeliveryMe}
                                        checked={deliveryMethod === '120'}

                                        style={{ border: '5px solid' }} />
                                    <button style={{ border: 'none', backgroundColor: 'white', fontWeight: '600', fontFamily: 'tiro bangla' }}>ঢাকার বাহিরে ১২০ টাকা</button>
                                </div>
                            </div><hr />
                            <div>




                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '80%', margin: '2px auto' }}>
                                <p className='subTotal'>Total Price</p>
                                <p className='subTotal'>{totalPrice}.0</p>
                            </div><hr />

                            <p className='COD'>
                                Cash on Delivery(COD)-পণ্য হাতে পেয়ে টাকা পরিশোধ করুন
                            </p>

                        </div>





                        <section style={{ textAlign: 'center', marginTop: '5%', width: '100%' }}>
                            <button className='orderProced' onClick={getOrder}><PiShoppingCartFill className='shoppingCart' />এখনই অর্ডার করুন</button>
                        </section>
                    </div>

                    <ToastContainer />

                </section>
















                <section className='footerSection' >
                    <p>
                        @all rights reserve by deshi agro foods || Hasib-IT Solution
                    </p>
                </section>
            </section>
        </>
    );
};

export default MosollaLanding;